import TwitchLogo from "./twitch-logo.svg";
import TwitchLogoSmall from "./twitch-small-logo.svg";
import TwitchLogoSmallWhite from "./twitch-small-logo-white.svg";
import TwitchPPicIcon from "./twitch-ppic-icon.svg";
import AmazonChannelLogo from "./amazon-channel-logo.svg";
import BlankUser from "./blank-user.jpg";
import TwitchGlitchGIF from "./twitch_glitch.gif";
import poweredByTwitch from "./Powered_By_Twitch.webm";
import Lock from "./lock.svg";
import Tick from "./tick.svg";

import CDGoGo from "./go-go.svg";
import CDPfGo from "./pf-go.svg";
import CDPoPf from "./po-pf.svg";
import CDPoPo from "./po-po.svg";

import StreamerPreviewBg from "./_streamerExampleBk.jpg";

import an_PlayOrderTopItem from './po-item-top.svg';
import an_PlayOrderItem from './po-items.svg';
import an_PlayOrderLine from './po-line.svg';

import wizDivider from './wiz-divider.svg';
import wizAlert from './wiz-alert.png';

import uplImgIcon from './upl-image.svg';
import uplVidIcon from './upl-video.svg';
import loadingGif from './iCast_Logo_Icon_Purp.gif';
// import buttonSpinner from './loading_2.gif';
// import loadingFeature from './loading_2.gif';
import buttonSpinner from './iCast_Logo_Icon_Roundel_Purp.gif';
import loadingFeature from './iCast_Logo_Icon_Roundel_Purp.gif';

import icastTopLogo from './ICAST_stacked_white.svg';
import icastFrontPageLogo from './ICAST_stacked_white_med.png';
import icastAnimatedLogo from './Icast_Logo_1.json';

import loginVideoBackground from './VIDEO_BACKGROUND.mp4';
import Ring from './Ring.png';

import darkModeToggle from './ToggleLightDark.json';
import streamIcon from './Stream_Icon.json';
import analyticsIcon from './Analytics_Icon.json';
import recordIcon from './Record_Icon.json';
import sharingIcon from './Sharing_Icon.json';

// Feature Icons (Lottie animations)
import FeatureWave from './Wave.json';
import FeatureFlock from './Flock 3.json';
import FeatureObjectZapper from './Object Zapper.json';
import FeatureLivePoll from './Live Poll.json';
import FeaturePoll from './Poll.json';
import FeatureSound from './Sound.json';
import FeatureVideo from './Video.json';
import FeatureFireworks from './Fireworks.json';
import FeatureConfetti from './Confetti.json';
import FeatureInfo from './Info.json';
import FeatureQuiz from './Quiz.json';
import FeatureLeaderboard from './Leaderboard.json';
import FeatureChallengeList from './ChallengeList-icon.json';
import FeatureCountdown from './Countdown.json';
import FeatureTimer from './Timer.json';
import FeatureImage from './Image.json';
import FeaturePuzzle from './Puzzle.json';
import FeatureClaw from './Claw.json';
import FeatureTugOfWar from './Tug of war.json';
import FeatureNineText from './Nine text.json';
import FeatureSlotMachine from './Slot Machine.json';
import FeatureWheel from './Wheel.json';
import FeatureProgressBar from './Progress Bar.json';
import FeatureSubCounter from './Sub Counter.json';
import FeatureInstructions from './Instructions.json';
import FeatureText from './Text.json';
import FeatureObjectSpawner from './Object_Spawner.json';
import FeatureExpedition from './Expidition.json';
import FeatureAnimatedOverlay from './Animated_Overlay.json';
import FeatureStatusScreen from './Status_Screen_Overlay.json';

export const featureIcons = {
    // Keys match actual database varKey values (camelCase)
    twitchWave: FeatureWave,
    flockToUnlock: FeatureFlock,
    objectZapper: FeatureObjectZapper,
    objectSpawner: FeatureObjectSpawner,
    livePoll: FeatureLivePoll,
    poll: FeaturePoll,
    disruptorAudio: FeatureSound,
    disruptorVideo: FeatureVideo,
    particleEffects: FeatureFireworks,
    particleEffects_fireworks: FeatureFireworks,
    particleEffects_confetti: FeatureConfetti,
    Confetti: FeatureConfetti,
    infoPanel: FeatureInfo,
    quizPoll: FeatureQuiz,
    liveTrivia: FeatureQuiz,
    leaderboard: FeatureLeaderboard,
    challengeList: FeatureChallengeList,
    countdown321: FeatureCountdown,
    timer: FeatureTimer,
    imageOverlay: FeatureImage,
    imageOverlay_simple: FeatureImage,
    animatedOverlay: FeatureAnimatedOverlay,
    contentSceneLibrary: FeatureStatusScreen,
    'slide-puzzle': FeaturePuzzle,
    clawMachine: FeatureClaw,
    statusScreens: FeatureStatusScreen,
    randomiser: FeatureWheel,
    randomiser_slots: FeatureSlotMachine,
    randomiser_wheel: FeatureWheel,
    subBomb: FeatureSubCounter,
    liveText: FeatureText,
    twitchHeader: FeatureInfo,
    quest: FeatureExpedition,
    progress_bar: FeatureProgressBar,
    instructions: FeatureInstructions,
    slot_machine: FeatureSlotMachine,
    tug_of_war: FeatureTugOfWar,
};

export const assets = {
    icastTopLogo: icastTopLogo,
    icastFrontPageLogo: icastFrontPageLogo,
    icastAnimatedLogo: icastAnimatedLogo,

    TwitchLogo: TwitchLogo,
    TwitchLogoSmall: TwitchLogoSmall,
    TwitchLogoSmallWhite: TwitchLogoSmallWhite,
    TwitchPPicIcon: TwitchPPicIcon,
    AmazonChannelLogo: AmazonChannelLogo,
    BlankUser: BlankUser,
    TwitchGlitchGIF:TwitchGlitchGIF,
    LoadingFeature:loadingFeature,
    PoweredByTwitch: poweredByTwitch,
    Lock: Lock,
    Tick: Tick,

    LoginVideoBackground: loginVideoBackground, 
    Ring: Ring,
    CampaignProgressDividerGoGo: CDGoGo,
    CampaignProgressDividerPfGo: CDPfGo,
    CampaignProgressDividerPoPf: CDPoPf,
    CampaignProgressDividerPoPo: CDPoPo,

    AnPlayOrderTopItem: an_PlayOrderTopItem,
    AnPlayOrderItem: an_PlayOrderItem,
    AnPlayOrderLine: an_PlayOrderLine,

    StreamerPreviewBg: StreamerPreviewBg,

    WizDivider: wizDivider,
    WizAlert: wizAlert,

    UplImgIcon: uplImgIcon,
    UplVidIcon: uplVidIcon,
    LoadingGif: loadingGif,
    ButtonSpinner: buttonSpinner,

    DarkModeToggle: darkModeToggle,
    StreamIcon: streamIcon,
    AnalyticsIcon: analyticsIcon,
    RecordIcon: recordIcon,
    SharingIcon: sharingIcon,
}

// alias for small powered-by graphic
export const PoweredByTwitch = TwitchLogoSmallWhite;

// An inline svg version of the Twitch Icon so we can change it's colour with css...
export const TwitchIconSvg = (
    <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.865 0L0 5V23H5.838V28L10.703 23H14.595L23.352 14V0H4.865ZM21.406 13L17.514 17H13.622L10.2165 20.5V17H5.838V2H21.406V13ZM18.487 5.5H16.541V11.5H18.487V5.5ZM13.1355 5.5H11.1895V11.5H13.1355V5.5Z" fill="white"/>
    </svg>
);

export const TwitchIconSvgPurple = (
    <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.865 0L0 5V23H5.838V28L10.703 23H14.595L23.352 14V0H4.865ZM21.406 13L17.514 17H13.622L10.2165 20.5V17H5.838V2H21.406V13ZM18.487 5.5H16.541V11.5H18.487V5.5ZM13.1355 5.5H11.1895V11.5H13.1355V5.5Z" fill="#9146FF"/>
    </svg>
);

export const TwitchIconSvgPurpleSmall = (
    <svg width="14" height="17" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.865 0L0 5V23H5.838V28L10.703 23H14.595L23.352 14V0H4.865ZM21.406 13L17.514 17H13.622L10.2165 20.5V17H5.838V2H21.406V13ZM18.487 5.5H16.541V11.5H18.487V5.5ZM13.1355 5.5H11.1895V11.5H13.1355V5.5Z" fill="#9146FF"/>
    </svg>
);
